export class AcuityCensusRecord {
    acuityCategoryId: number;
    id: number;
    modifiedByUserName: string;
    modifiedDate: Date;
    patients: number;
    shiftRecordId: number;
}